<template>
  <b-navbar-brand href="/#/">
    <div class="navbar-logo"></div>
  </b-navbar-brand>
</template>

<script>
export default {
  name: 'NavbarBrand',
};
</script>
